import React, { useLayoutEffect } from 'react';

import './AddToCartOrList.scss';
import { RadioButton, RadioGroup } from '../RadioGroup';
import { ListActionTarget } from '../../../../models/ListActionTarget';
import { useTranslation } from 'react-i18next';
import { useTarget } from '../useTarget';

/**
 * Props for <AddToCartOrList>.
 */
interface AddToCartOrListProps {
    readonly disabledAddToList?: boolean;

    readonly disabledAddToCart?: boolean;
}

export function AddToCartOrList({ disabledAddToList, disabledAddToCart }: AddToCartOrListProps) {
    const { t } = useTranslation();
    const { target, setTarget } = useTarget();

    useLayoutEffect(() => {
        if (disabledAddToList && target === ListActionTarget.List) {
            setTarget(ListActionTarget.Cart);
        }
    }, [disabledAddToList, setTarget, target]);

    return (
        <div className="add-to-selector">
            <div className="text">{t('components.addToCartOrList.addTo')}</div>
            <RadioGroup
                value={target}
                onChange={newTarget => setTarget(newTarget as ListActionTarget)}
                className="add-to-selector-buttons"
            >
                <RadioButton selectedClassName="selected" value={ListActionTarget.List} disabled={disabledAddToList}>
                    <i className="material-icons">add</i>
                    {t('components.addToCartOrList.list')}
                </RadioButton>
                <RadioButton selectedClassName="selected" value={ListActionTarget.Cart} disabled={disabledAddToCart}>
                    <i className="material-icons">shopping_cart</i>
                    {t('components.addToCartOrList.cart')}
                </RadioButton>
            </RadioGroup>
        </div>
    );
}
